// src/components/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footercolumn">
        <h3>Quick Links</h3>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/cybersecurity">Cybersecurity</Link></li>
          <li><Link to="/privacypolicy">Privacy Policy</Link></li>
          <li><Link to="/PurchaseAndRefundPolicy">Purchase & Refund Policy</Link></li>
          <li><Link to="/termsandconditions">Terms & Conditions</Link></li>
          <li><Link to="/contactus">Contact Us</Link></li>
        </ul>
      </div>
      <div className="footercolumn">
        <h3>Mission</h3>
        <p>
          <i>"Join the next stage of human evolution and become more than human."</i>
        </p>
      </div>
      <div className="footercolumn">
        <h3>Acknowledgments</h3>
        <div className="acknowledgment-flags">
          <div className="flag-item">
            <img src="/assets/graphics/site-wide/lgbt-flag.png" alt="Pride Flag" className="footer-flag" />
            <p>We proudly support LGBTQIA+ rights and embrace diversity in all its forms.</p>
          </div>
          <div className="flag-item">
            <img src="/assets/graphics/site-wide/aboriginal-flag.png" alt="Aboriginal Flag" className="footer-flag" />
            <p>We acknowledge the Traditional Custodians of the land on which we operate, the Gadigal people of the Eora Nation, and pay our respects to Elders past, present, and emerging.</p>
          </div>
        </div>
      </div>
      <div className="footercolumn" style={{ fontSize: '0.95em', lineHeight: '1.6' }}>
        <strong>ABN:</strong> 89 655 184 946<br />
        <strong>ACN:</strong> 655 184 946<br />
        &copy; 2021–{new Date().getFullYear()} Sabrenetics PTY LTD. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
